import { request } from '@blade/common';
// import { Portrait, SearchResult, CompareData, Libraries, Library, ResultForOnetpN, PageList } from '@blade-sxp/tools/interfaces';
// 上传图片查询档案库
export const getResult = (data) => request({
    url: '/api/entity-skill-management/api/v1/entity/document/search',
    method: 'POST',
    data,
});
// 聚档任务
export const getAllTaskList = (data) => request({
    url: '/api/task-management/api/v1/task/list/all',
    method: 'POST',
    data,
});
// 聚档任务
export const getSearch = (data) => request({
    url: '/api/entity-skill-management/api/v1/entity/search',
    method: 'POST',
    data,
});
// 查看详情
export const getDetail = (data) => request({
    url: '/api/entity-skill-management/api/v1/entity/search/detail',
    method: 'POST',
    data,
});
// 查看详情单个任务
export const searchByObjectId = (data) => request({
    url: '/api/timedb-management/api/v1/search/searchByObjectId',
    method: 'POST',
    data,
});
